import {
    Button
} from 'shared/components/ui/button';
import {
    ChevronLeft, ChevronRight
} from 'lucide-react';

// Define the props interface
interface RecordsPaginationProps {
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    totalPages: number;
    totalRecords: number;
}

export function RecordsPagination({
    currentPage,
    setCurrentPage,
    totalPages,
    totalRecords
}: RecordsPaginationProps) {
    return (
        <div className="flex items-center justify-between p-4 border-t mt-6">
            <div className="text-sm text-muted-foreground">{totalRecords} records</div>
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <Button
                        variant="outline"
                        size="icon"
                        onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                    >
                        <ChevronLeft className="h-4 w-4" />
                    </Button>
                    <div className="flex items-center gap-1 text-sm">
                        <span>Page</span>
                        <span className="font-medium">{currentPage}</span>
                        <span>of</span>
                        <span className="font-medium">{totalPages}</span>
                    </div>
                    <Button
                        variant="outline"
                        size="icon"
                        onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                        disabled={currentPage === totalPages}
                    >
                        <ChevronRight className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </div>
    );
}
